import TwoStepRegisterModal from './TwoStepRegisterModal';

export default TwoStepRegisterModal;
